<template>
  <div>
    <Header />
    <Nav />
    <div class="body pb70">
      <div class="menu bgc"></div>
      <div class="container">
        <div class="platform_intro">
          <!-- <div>
            为推动人力资源信息防伪溯源的发展和提高社会人力资源利用水平，
            
            中国防伪行业协会“
            <span class="tooltip"
              >全国产品防伪溯源验证公共平台<span class="tooltiptext"
                ><span class="hov"></span
                >全国产品防伪溯源验证公共平台，是在全国双打办和国家市场监督管理总局指导下，由中国防伪行业协会和中国产学研合作促进会反侵权假冒创新战略联盟共同发起，联合相关行业商、协会和联盟，以及知名企业共同搭建的第三方权威、公正、具有公信力的信息服务平台。
                <br /><a
                  href="https://baike.baidu.com/item/%E5%85%A8%E5%9B%BD%E4%BA%A7%E5%93%81%E9%98%B2%E4%BC%AA%E6%BA%AF%E6%BA%90%E9%AA%8C%E8%AF%81%E5%85%AC%E5%85%B1%E5%B9%B3%E5%8F%B0/20135960?fr=aladdin"
                  target="_blank"
                  >详细信息</a
                ></span
              ></span
            >”提出了【溯源优才计划】，从教育过程到就业职场经历以及社会生活深度溯源，重新定义人力资源信息追溯体系。
          </div> -->
          <div>
            为推动人力资源信息防伪溯源的发展和提高社会人力资源利用水平，“<span
              class="tooltip"
              >中国防伪行业协会<span class="tooltiptext">
                <span class="hov"></span
                >中国防伪行业协会成立于1995年，其业务指导部门为国家市场监督管理总局，党建工作机构为中央和国家机关工作委员会。协助政府部门研究制定我国防伪行业发展战略、发展规划、法规、政策，开展对防伪行业的监督管理工作。
                <br />
                <a href="http://www.ctaac.org.cn/" target="_blank"
                  >http://www.ctaac.org.cn/</a
                ></span
              ></span
            >”提出了【溯源优才计划】，从教育过程到就业职场经历以及社会生活深度溯源，重新定义人力资源信息追溯体系。中国防伪行业协会下属的“人力资源信息追溯专业委员会”负责【溯源优才计划】的体系规划、技术指导、和业务监管支持工作。
          </div>
          <img
            class="pic1"
            src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/intro_pic1.png"
            alt=""
          />
          <div>
            【溯源优才计划】由“全国人力资源信息数据验证平台”和“溯源优才服务平台”构成，其中“全国人力资源信息数据验证平台”是由中国防伪行业协会
            “
            <span class="tooltip"
              >全国产品防伪溯源验证公共平台<span class="tooltiptext"
                ><span class="hov"></span
                >全国产品防伪溯源验证公共平台，是在全国双打办和国家市场监督管理总局指导下，由中国防伪行业协会和中国产学研合作促进会反侵权假冒创新战略联盟共同发起，联合相关行业商、协会和联盟，以及知名企业共同搭建的第三方权威、公正、具有公信力的信息服务平台。
                <br /><a
                  href="https://baike.baidu.com/item/%E5%85%A8%E5%9B%BD%E4%BA%A7%E5%93%81%E9%98%B2%E4%BC%AA%E6%BA%AF%E6%BA%90%E9%AA%8C%E8%AF%81%E5%85%AC%E5%85%B1%E5%B9%B3%E5%8F%B0/20135960?fr=aladdin"
                  target="_blank"
                  >详细信息</a
                ></span
              ></span
            >”建立的国家数据平台，通过5G、区块链等技术支撑人才追溯时大量数据存储及传输，保障全链条信息可验证、有依据，构建不可篡改且具有国家公信力的人力资源信息数据查验系统。
          </div>

          <!-- <div>
            “溯源优才服务平台”经<span class="tooltip"
              >中国防伪行业协会<span class="tooltiptext">
                <span class="hov"></span
                >中国防伪行业协会成立于1995年，其业务指导部门为国家市场监督管理总局，党建工作机构为中央和国家机关工作委员会。协助政府部门研究制定我国防伪行业发展战略、发展规划、法规、政策，开展对防伪行业的监督管理工作。
                <br />
                <a href="http://www.ctaac.org.cn/" target="_blank"
                  >http://www.ctaac.org.cn/</a
                ></span
              ></span
            >“全国产品防伪溯源验证公共平台”的<span class="tooltip"
              >独家授权
              <span class="tooltiptext ideFile">
                <span class="hov"></span
                ><img
                  src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/001.jpg"
                  alt=""
                  onclick="preview(this)"
                />
              </span> </span
            >，由成都德锋创享科技有限公司建设运营，是“全国人力资源信息数据验证平台”的唯一数据应用与商业服务通道。“溯源优才服务平台”一方面在全国产品防伪溯源验证公共平台的监管下建立完善国家数据库的人力资源信息数据接口及数据规范体系；另一方面对全社会提供个人授权采集、本人查验、授权增信展示服务，对教育机构、用人单位、社会团体提供形式多样的人力资源信息数据采集、加密存储、查验服务；同时还针对各种涉及人力资源信息采集、存储、查验、增信展示的第三方应用，在防伪溯源的前提下，提供相关数据及业务接口合作支撑。
          </div> -->
          <div>
            “溯源优才服务平台”是“全国人力资源信息数据验证平台”的唯一数据应用与商业服务通道。“溯源优才服务平台”一方面在全国产品防伪溯源验证公共平台的监管下建立完善国家数据库的人力资源信息数据接口及数据规范体系；另一方面对全社会提供个人授权信息归集、本人查验报告、授权增信展示服务，对教育机构、用人单位、社会团体提供形式多样的人力资源信息数据归集、加密溯源、查验报告服务；同时还针对各种涉及人力资源信息采集、查验、增信展示的第三方应用，在防伪溯源的前提下，提供相关数据及业务接口合作支撑。
          </div>
          <!-- <div>
            成都德锋创享科技有限公司，作为“全国人力资源信息数据验证平台”的唯一对外服务商、【溯源优才】计划唯一的运营管理主体，在中国防伪行业协会的指导监管下开展【溯源优才】计划全国范围内的推广运营工作。
            <br/>“溯源优才服务平台”一方面在“
            <span class="tooltip"
              >全国产品防伪溯源验证公共平台<span class="tooltiptext"
                ><span class="hov"></span
                >全国产品防伪溯源验证公共平台，是在全国双打办和国家市场监督管理总局指导下，由中国防伪行业协会和中国产学研合作促进会反侵权假冒创新战略联盟共同发起，联合相关行业商、协会和联盟，以及知名企业共同搭建的第三方权威、公正、具有公信力的信息服务平台。
                <br /><a
                  href="https://baike.baidu.com/item/%E5%85%A8%E5%9B%BD%E4%BA%A7%E5%93%81%E9%98%B2%E4%BC%AA%E6%BA%AF%E6%BA%90%E9%AA%8C%E8%AF%81%E5%85%AC%E5%85%B1%E5%B9%B3%E5%8F%B0/20135960?fr=aladdin"
                  target="_blank"
                  >详细信息</a
                ></span
              ></span
            >”的监管下建立完善国家数据库的人力资源信息数据接口及数据规范体系；另一方面对全社会提供个人授权采集、本人查验、授权增信展示服务，对教育机构、用人单位、社会团体提供形式多样的人力资源信息数据采集、加密存储、查验服务；同时还针对各种涉及人力资源信息采集、存储、查验、增信展示的第三方应用，在防伪溯源的前提下，提供相关数据及业务接口合作支撑。
          </div> -->
          <img
            class="pic2"
            src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/intro_pic2.png"
            alt=""
          />
          <div>
            “全国人力资源信息数据验证平台”的唯一对外服务商、【溯源优才计划】唯一的运营管理主体为成都德锋尚享科技公司，在中国防伪行业协会的指导监管下开展【溯源优才计划】全国范围内的推广运营工作。
          </div>
          <div>
            溯源优才计划相关的所有数据权限，均经相关本人授权后归集于国家数据平台，严格遵守国家数据库安全要求规范管理，并提供数据档案
            <span class="tooltip"
              >数据勘误通道<span class="tooltiptext"
                ><span class="hov"></span
                >若您对个人数据报告存在异议，可通过平台数据勘误通道进行举证或申诉。<a
                  href="/personalServicesHome"
                  >我要勘误>></a
                >
              </span></span
            >及投诉建议通道，欢迎社会各界监督指正。欢迎各类政府部门、教育机构、用人单位、社会团体、三方应用与平台开展合作，敬请<span
              @click="isContactUsShow = true"
              class="tooltip"
              >联系我们 </span
            >。
          </div>
          <!-- <div>
            溯源优才计划相关的所有数据，均经相关本人授权后采集存储于国家数据库中，严格遵守国家数据库安全要求规范管理，并提供数据档案
            <span class="tooltip"
              >数据勘误通道<span class="tooltiptext"
                ><span class="hov"></span
                >若您对个人数据报告存在异议，可通过平台数据勘误通道进行举证或申诉。<a
                  href="/personalServicesHome"
                  >我要勘误>></a
                >
              </span></span
            >及投诉建议通道，欢迎社会各界监督指正。欢迎各类教育机构、用人单位、社会团体、三方应用与平台开展合作，敬请<br /><span
              @click="isContactUsShow = true"
              class="tooltip"
              >联系我们 </span
            >。
          </div> -->
        </div>
      </div>
    </div>
    <Footer />
    <DialogContactUs :isShow="isContactUsShow" @handleClose="handleCtuClose" />
  </div>
</template>

<script>
import DialogContactUs from "../../components/DialogContactUs.vue";
import Footer from "../../components/Footer.vue";
import Header from "../../components/Header.vue";
import Nav from "../../components/Nav.vue";

export default {
  components: { Header, Footer, Nav, DialogContactUs },
  data() {
    return {
      isContactUsShow: false
    };
  },
  methods: {
    handleCtuClose() {
      this.isContactUsShow = false;
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  padding-bottom: 70px;
  display: inline-block;
  width: 100%;
  background-color: #f0f2f5;
  .platform_intro {
    // padding: 95px 176px 100px 174px;
    padding: 95px 170px 100px 173px;
    margin: 40px 0 0px 0;
    line-height: 30px;
    background: #fff;
    font-size: 14px;
    color: #6e6e6e;
    span {
      color: #5673b0;
      cursor: pointer;
    }
    .pic1 {
      width: 622px;
      margin-left: 115px;
      margin-top: 64px;
      margin-bottom: 68px;
    }
    .pic2 {
      width: 692px;
      margin-left: 80px;
      margin-top: 44px;
      margin-bottom: 58px;
    }
    img {
      width: 100%;
    }
  }
}
.platform_intro {
  // padding: 95px 176px 100px 174px;
  padding: 95px 170px 100px 173px;
  margin: 40px 0 0px 0;
  line-height: 30px;
  background: #fff;
  font-size: 14px;
  color: #6e6e6e;
  span {
    color: #5673b0;
    cursor: pointer;
  }
  .pic1 {
    width: 622px;
    margin-left: 115px;
    margin-top: 64px;
    margin-bottom: 68px;
  }
  .pic2 {
    width: 692px;
    margin-left: 80px;
    margin-top: 44px;
    margin-bottom: 58px;
  }
  img {
    width: 100%;
  }
}
.tooltip {
  position: relative;
  &:hover {
    .tooltiptext {
      visibility: visible;
    }
  }
  .tooltiptext {
    border: 1px solid #98aed9;
    visibility: hidden;
    width: 322px;
    background-color: #f5f7fa;
    color: #6e6e6e !important;
    font-size: 12px;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 150%;
    // left: 50%;
    left: 25%;
    margin-left: -160px;
    padding: 26px 23px 29px 23px;
    box-shadow: 0px 0px 10px -5px rgb(58, 97, 177, 0.29);
    .hov {
      width: 100%;
      display: inline-block;
      height: 20px;
      position: absolute;
      top: -15px;
      left: 0;
    }
    a {
      color: #5673b0;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #98aed9 transparent;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 99%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #f5f7fa transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/intro/index.vue